export function printNode(title: string, node: HTMLElement, styles?: string) {
    // To debug print code uncomment code and comment out the code below
    // const win = window.open('', 'PrintWindow');
    // win.document.title = title;
    // win.document.body.append(node);
    // setTimeout(() => {
    //     win.document.close();
    //     win.focus();
    //     win.print();
    //     win.close();
    // }, 1000);

    const printFrame = document.createElement('iframe');
    printFrame.name = 'printFrame';
    printFrame.style.position = 'absolute';
    printFrame.style.top = '-1000000px';
    document.body.appendChild(printFrame);
    const frameDoc = printFrame.contentDocument;

    if (!frameDoc) {
        throw new Error('Cannot print node. No iframe content document.');
    }

    frameDoc.title = title;

    if (styles) {
        const docStyle = document.createElement('style');
        docStyle.textContent = styles;
        frameDoc.head.appendChild(docStyle);
    }
    frameDoc.body.append(node);

    setTimeout(() => {
        const { contentWindow } = printFrame;
        if (!contentWindow) {
            throw new Error('Could not get window of <iframe> element');
        }

        contentWindow.focus();
        contentWindow.print();
        document.body.removeChild(printFrame);
    }, 500);
}

/**
 * Query the children of an `HTMLSlotElement` using a CSS query selector string.
 */
export function querySlot<T extends Element>(slot: HTMLSlotElement, selector: string) {
    const slottedElements = slot.assignedElements({
        flatten: true,
    });

    const matches = slottedElements.filter(elem => elem.matches(selector));
    if (matches.length > 0) {
        return matches[0] as T;
    }

    for (const elem of slottedElements) {
        const queryResult = elem.querySelector<T>(selector);

        if (queryResult) {
            return queryResult;
        }
    }

    return undefined;
}

/**
 * Query the children of an `HTMLSlotElement` using a CSS query selector string.
 * Returns all matching elements.
 * @param slot - The slot to query.
 * @param selector - The CSS selector to use.
 * @returns All matching elements.
 */
export function querySlotAll<T extends Element>(slot: HTMLSlotElement, selector: string) {
    const slottedElements = slot.assignedElements({
        flatten: true,
    });
    const matches = slottedElements.filter(elem => elem.matches(selector));
    if (matches.length > 0) {
        return matches as T[];
    }
    const queriedElements = slottedElements.flatMap(elem =>
        Array.from(elem.querySelectorAll<T>(selector))
    );
    if (queriedElements.length > 0) {
        return queriedElements;
    }
    return [] as T[];
}

export async function waitForAnimations(a: Animatable) {
    const animationPromises = a.getAnimations().map((a: Animation) => a.finished);
    await Promise.all(animationPromises);
}
